var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Turma ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma*",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ano Letivo*",
      "item-text": "ano",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listAnosLetivos,
      "disabled": ""
    },
    model: {
      value: _vm.content.anoLetivo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "anoLetivo", $$v);
      },
      expression: "content.anoLetivo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ano/Serie*",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listAnoSeries,
      "disabled": ""
    },
    model: {
      value: _vm.content.serie,
      callback: function ($$v) {
        _vm.$set(_vm.content, "serie", $$v);
      },
      expression: "content.serie"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Turno*",
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listTurnos,
      "disabled": ""
    },
    model: {
      value: _vm.content.turno,
      callback: function ($$v) {
        _vm.$set(_vm.content, "turno", $$v);
      },
      expression: "content.turno"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Município*",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listMunicipios,
      "disabled": ""
    },
    model: {
      value: _vm.content.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "municipio", $$v);
      },
      expression: "content.municipio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Escola*",
      "item-text": "local",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listEscolas,
      "disabled": ""
    },
    model: {
      value: _vm.content.escola,
      callback: function ($$v) {
        _vm.$set(_vm.content, "escola", $$v);
      },
      expression: "content.escola"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Professor(a) de Língua Portuguesa*",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listProfessor,
      "disabled": ""
    },
    model: {
      value: _vm.content.professorPortugues,
      callback: function ($$v) {
        _vm.$set(_vm.content, "professorPortugues", $$v);
      },
      expression: "content.professorPortugues"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Professor(a) de Matemática*",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listProfessor,
      "disabled": ""
    },
    model: {
      value: _vm.content.professorMatematica,
      callback: function ($$v) {
        _vm.$set(_vm.content, "professorMatematica", $$v);
      },
      expression: "content.professorMatematica"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantidade de Alunos*",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.quantidadeAlunos,
      callback: function ($$v) {
        _vm.$set(_vm.content, "quantidadeAlunos", $$v);
      },
      expression: "content.quantidadeAlunos"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }